<div class="container-fluid bg-white vh-100 p-0">
    <ClientLogo v-if="this.$route.name != 'behalf_application'" />
    <BreadCrumb label="RSA ID Verification" />

    <div>
        <div class="d-flex justify-content-center align-items-center min-vh-50">
        <div class="col-11 col-sm-10 col-md-8 col-lg-6 col-xl-5 p-3">
            <div class="d-flex align-items-center">
            <span><i class="text-muted bi bi-question-circle me-2"></i></span>
            <span class="text-muted text-xs">
                The RSA ID verification process validates South African identity information against official records,
                ensuring accuracy and compliance with government databases.
            </span> 
            </div> 
            
            <!-- ID Number Field -->
            <div class="form-group mt-3">
            <label for="id_number" class="form-label fw-bold text-xxs">
                ID Number <span class="text-danger fw-bold">*</span>
            </label>
            <input 
                id="id_number" 
                type="text"
                class="form-control mx-auto col-12 col-md-9 col-lg-8 text-xxs rounded-small p-2 shadow-sm"
                :value="id_number"
                placeholder="Enter ID Number"
                maxlength="13"
                @input="allow_numeric"
                :disabled="is_field_disabled.id_number">
            <div class="mt-3 d-flex flex-column text-center col-12 col-md-9 col-lg-8 mx-auto">
                <small class="text-danger fw-bold text-xs d-none id-message">
                Please fill in this field
                </small>
                <small class="text-danger fw-bold text-xs d-none invalid-id-message">
                Please enter a valid 13-digit ID number
                </small>
            </div>
            </div>
            
            <!-- First Name Field -->
            <div class="form-group mt-3">
            <label for="first_name" class="form-label fw-bold text-xxs">
                First Name <span class="text-danger fw-bold">*</span>
            </label>
            <input 
                id="first_name" 
                type="text"
                class="form-control mx-auto col-12 col-md-9 col-lg-8 text-xxs rounded-small p-2 shadow-sm"
                :value="first_name"
                placeholder="Enter First Name"
                maxlength="50"
                @input="allow_alphabetic"
                :disabled="is_field_disabled.first_name">
            <div class="mt-3 d-flex flex-column text-center col-12 col-md-9 col-lg-8 mx-auto">
                <small class="text-danger fw-bold text-xs d-none first-name-message">
                Please fill in this field
                </small>
            </div>
            </div>
            
            <!-- Last Name Field -->
            <div class="form-group mt-3">
            <label for="last_name" class="form-label fw-bold text-xxs">
                Last Name <span class="text-danger fw-bold">*</span>
            </label>
            <input 
                id="last_name" 
                type="text"
                class="form-control mx-auto col-12 col-md-9 col-lg-8 text-xxs rounded-small p-2 shadow-sm"
                :value="last_name"
                placeholder="Enter Last Name"
                maxlength="50"
                @input="allow_alphabetic"
                :disabled="is_field_disabled.last_name">
            <div class="mt-3 d-flex flex-column text-center col-12 col-md-9 col-lg-8 mx-auto">
                <small class="text-danger fw-bold text-xs d-none last-name-message">
                Please fill in this field
                </small>
            </div>
            </div>
        </div>
        </div>
        
        <div class="text-center">
        <button
            type="button"
            class="btn bg-green btn-sm mt-1 rounded-small shadow-sm fw-bold secondary-text-dark text-xs"
            :disabled="!is_id_valid"
            @click="verify_rsa_id"
        >
            continue
        </button>
        </div>
    </div>
</div>